<template>
    <div class="row">
        <div class="col-xl-8 col-xxl-9 d-flex flex-column">
            <div class="block block-rounded flex-grow-1 d-flex flex-column">
                <div class="block-header block-header-default">
                    <h3 class="block-title">Earnings Summary</h3>
                    <div class="block-options">
                        <button type="button" class="btn-block-option" data-toggle="block-option"
                            data-action="state_toggle" data-action-mode="demo">
                            <i class="si si-refresh"></i>
                        </button>
                        <button type="button" class="btn-block-option">
                            <i class="si si-settings"></i>
                        </button>
                    </div>
                </div>
                <div class="block-content block-content-full flex-grow-1 d-flex align-items-center">
                    <canvas id="js-chartjs-earnings"
                        style="display: block; box-sizing: border-box; height: 419px; width: 836px;" width="836"
                        height="419"></canvas>
                </div>
                <div class="block-content bg-body-light">
                    <div class="row items-push text-center w-100">
                        <div class="col-sm-4">
                            <dl class="mb-0">
                                <dt class="fs-3 fw-bold d-inline-flex align-items-center space-x-2">
                                    <i class="fa fa-caret-up fs-base text-success"></i>
                                    <span>2.5%</span>
                                </dt>
                                <dd class="fs-sm fw-medium text-muted mb-0">Customer Growth</dd>
                            </dl>
                        </div>
                        <div class="col-sm-4">
                            <dl class="mb-0">
                                <dt class="fs-3 fw-bold d-inline-flex align-items-center space-x-2">
                                    <i class="fa fa-caret-up fs-base text-success"></i>
                                    <span>3.8%</span>
                                </dt>
                                <dd class="fs-sm fw-medium text-muted mb-0">Page Views</dd>
                            </dl>
                        </div>
                        <div class="col-sm-4">
                            <dl class="mb-0">
                                <dt class="fs-3 fw-bold d-inline-flex align-items-center space-x-2">
                                    <i class="fa fa-caret-down fs-base text-danger"></i>
                                    <span>1.7%</span>
                                </dt>
                                <dd class="fs-sm fw-medium text-muted mb-0">New Products</dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-4 col-xxl-3 d-flex flex-column">
            <div class="row items-push flex-grow-1">
                <div class="col-md-6 col-xl-12">
                    <div class="block block-rounded d-flex flex-column h-100 mb-0">
                        <div class="block-content flex-grow-1 d-flex justify-content-between">
                            <dl class="mb-0">
                                <dt class="fs-3 fw-bold">570</dt>
                                <dd class="fs-sm fw-medium text-muted mb-0">Total Orders</dd>
                            </dl>
                            <div>
                                <div
                                    class="d-inline-block px-2 py-1 rounded-3 fs-xs fw-semibold text-danger bg-danger-light">
                                    <i class="fa fa-caret-down me-1"></i>
                                    2.2%
                                </div>
                            </div>
                        </div>
                        <div class="block-content p-1 text-center overflow-hidden">
                            <canvas id="js-chartjs-total-orders"
                                style="height: 90px; display: block; box-sizing: border-box; width: 265px;" width="265"
                                height="90"></canvas>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-xl-12">
                    <div class="block block-rounded d-flex flex-column h-100 mb-0">
                        <div class="block-content flex-grow-1 d-flex justify-content-between">
                            <dl class="mb-0">
                                <dt class="fs-3 fw-bold">$5,234.21</dt>
                                <dd class="fs-sm fw-medium text-muted mb-0">Total Earnings</dd>
                            </dl>
                            <div>
                                <div
                                    class="d-inline-block px-2 py-1 rounded-3 fs-xs fw-semibold text-success bg-success-light">
                                    <i class="fa fa-caret-up me-1"></i>
                                    4.2%
                                </div>
                            </div>
                        </div>
                        <div class="block-content p-1 text-center overflow-hidden">
                            <canvas id="js-chartjs-total-earnings"
                                style="height: 90px; display: block; box-sizing: border-box; width: 265px;" width="265"
                                height="90"></canvas>
                        </div>
                    </div>
                </div>
                <div class="col-xl-12">
                    <div class="block block-rounded d-flex flex-column h-100 mb-0">
                        <div class="block-content flex-grow-1 d-flex justify-content-between">
                            <dl class="mb-0">
                                <dt class="fs-3 fw-bold">264</dt>
                                <dd class="fs-sm fw-medium text-muted mb-0">New Customers</dd>
                            </dl>
                            <div>
                                <div
                                    class="d-inline-block px-2 py-1 rounded-3 fs-xs fw-semibold text-success bg-success-light">
                                    <i class="fa fa-caret-up me-1"></i>
                                    9.3%
                                </div>
                            </div>
                        </div>
                        <div class="block-content p-1 text-center overflow-hidden">
                            <canvas id="js-chartjs-new-customers"
                                style="height: 90px; display: block; box-sizing: border-box; width: 265px;" width="265"
                                height="90"></canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>